import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { formatGameTime } from "../format/formatGameTime";
import { formatPickRate } from "../format/formatPickRate";
import type { FixOf } from "../model/Fix";
import { AssetList } from "./AssetList";

const LABEL = msg({
  id: "analysis.fix.resist_items",
  message:
    "{kind, select, bullet {Bullet} spirit {Spirit} other {Melee}} resistance strong players on your hero take:",
});

const USUALLY_BY = msg({ id: "analysis.fix.resist_items.usual", message: "{pick} · by {time}" });

const FIX = msg({ id: "analysis.fix.label", message: "How to fix:" });

const LATE = msg({
  id: "analysis.fix.resist_items.late",
  message:
    "get {kind, select, bullet {bullet} spirit {spirit} other {melee}} resistance earlier. Strong players on your hero buy {item} by {baseline} on average, you got it only at {bought}.",
});

// Защита от типа урона, которым били игрока, — популярная у сильных игроков на его герое.
// Самую популярную игрок купил, но поздно — одна фраза: когда её берут сильные и когда взял он.
export const ResistItemsFix = ({ fix }: { fix: FixOf<"resist_items"> }) => {
  const { i18n } = useLingui();
  const findItem = useAssetLookup("items");
  const [first] = fix.params.items;
  if (
    first?.bought_at_s != null &&
    first.baseline_at_s != null &&
    first.bought_at_s > first.baseline_at_s
  ) {
    const item = findItem(first.item_id);
    return (
      <div className="flex items-center gap-3">
        <AssetIcon asset={item} size={44} className="rounded-lg" />
        <p className="text-sm text-foreground">
          <span className="font-semibold text-accent">{i18n._(FIX)}</span>{" "}
          {i18n._({
            ...LATE,
            values: {
              kind: fix.params.damage_kind,
              item: item.name,
              baseline: formatGameTime(first.baseline_at_s),
              bought: formatGameTime(first.bought_at_s),
            },
          })}
        </p>
      </div>
    );
  }
  return (
    <AssetList
      label={i18n._({ ...LABEL, values: { kind: fix.params.damage_kind } })}
      entries={fix.params.items.map((item) => {
        const pick = formatPickRate(item.pick_rate, i18n.locale);
        return {
          asset: findItem(item.item_id),
          caption:
            item.baseline_at_s == null
              ? pick
              : i18n._({
                  ...USUALLY_BY,
                  values: { pick, time: formatGameTime(item.baseline_at_s) },
                }),
        };
      })}
    />
  );
};
